import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'
import { ROUTES } from '../routes'

/**
 * Redirige vers le dashboard si l'utilisateur est déjà connecté.
 * Attend la fin de l'hydratation avant de décider.
 */
export function GuestGuard({ children }: { children?: React.ReactNode }) {
  const { isAuthenticated, isLoading, _hasHydrated } = useAuthStore()

  // Même attente que AuthGuard — évite la boucle
  if (isLoading || !_hasHydrated) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: 'var(--sb-bg)',
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: '50%',
          border: '3px solid rgba(255,255,255,0.15)', borderTopColor: 'var(--brand-orange)',
          animation: 'spin .7s linear infinite',
        }}/>
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
